import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, TrashIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiCheckUp from "../../api/ApiCheckup";
import ApiImage from "../../api/ApiImage";
import { CheckFile, dataURLtoFile } from "../../utils";
import CSwl from "../../utils/alert";
import loadImage from "blueimp-load-image/js";
import { useDispatch, useSelector } from "react-redux";
import ApiAccount from '../../api/ApiAccount';
import { useTranslation } from 'react-i18next';
const QAPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);

    const [listQA, setlistQA] = useState([]);
    useEffect(() => {
        getListStatus3();
    }, []);

    const getListStatus3 = async () => {
        CSwl.SwalLoad();
        console.log('user::', user)
        const qaList = await ApiAccount.getListQA(user.officerCode);
        if (qaList.status == 200) {
            setlistQA(qaList.data.listQA)
        }
        CSwl.SwalClose();
    }

    return <div className="pb-5">
        <div className="flex flex-col gap-y-4">
            <table className="mt-2 table-auto border-collapse border border-slate-500 w-full">
                <thead>
                    <tr>
                        <th className="bg-blue text-white">{t('qa.truckReg')}</th>
                        <th className="bg-blue text-white">Shipment No.</th>
                        <th className="bg-blue text-white">DP No. (SO)</th>
                    </tr>
                </thead>
                <tbody className="pb-2">
                    {
                        listQA.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="text-center text-slate-500 py-4">
                                    {t('qa.noPendingShipment')}
                                </td>
                            </tr>
                        ) : (
                            listQA.map((data, indexData) => (
                                <tr key={indexData}>
                                    <td className="text-center">{data.truckId}</td>
                                    <td className="text-center">{data.shipmentNo}</td>
                                    <td
                                        onClick={() => {
                                            navigate(`/jobQA?type=pickup&dpno=${data.dpno}&shipment=${data.shipmentNo}&truckid=${data.truckId}`);
                                        }}
                                        className="text-center text-blue cursor-pointer"
                                    >
                                        <div className="flex flex-col">
                                            <div>{data.dpno}</div>
                                            {data.orderNo?.split(',').map((order, idx) => (
                                                <span key={idx} className="text-slate-800">
                                                    ({order})
                                                </span>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )
                    }
                </tbody>
            </table>
        </div>
    </div>
}



export default QAPage;